import React, { useState, useEffect } from "react";
import {
  withGoogleMap,
  withScriptjs,
  GoogleMap,
  Marker,
  InfoWindow
} from "react-google-maps";
import myMarkers from "../../puntos_ventas.json"
import mapStyles from "./mapStyles";

function Map() {
  const [selectedPark, setSelectedPark] = useState(null);

  useEffect(() => {
    const listener = e => {
      if (e.key === "Escape") {
        setSelectedPark(null);
      }
    };
    window.addEventListener("keydown", listener);

    return () => {
      window.removeEventListener("keydown", listener);
    };
  }, []);

  const parkingData = {
    features: [
        {
            parkid: 11,
            longitud: -58.915145525398,
            latitud: -34.458150645261085,
            nombre: "mio",
            direccion: "es mio"
        
        },
        {
            parkid: 12,
            longitud: "-58.91471988992018", 
            latitud: "-34.45733542025778",
            nombre: "tuyo",
            direccion: "es tuyo"

        }
    ]
  };

  return (
    <GoogleMap
      defaultZoom={16.3}
      defaultCenter={{ lat: -34.4591842, lng: -58.9135317 }}
      defaultOptions={{ styles: mapStyles }}
    >
        {myMarkers.extra.comercios.map(park =>  
        
        (
        <Marker
          key={park.nombre}
          position={{
            lat: parseFloat(park.latitud),
            lng: parseFloat(park.longitud),
          }}
          onClick={() => {
            setSelectedPark(park);
          }}
          icon={{
            url: `/estacionamiento-pto-vta-icon.png`,
            scaledSize: new window.google.maps.Size(25, 35)
          }}
        />
      ))}

      {selectedPark && (
        <InfoWindow
          onCloseClick={() => {
            setSelectedPark(null);
          }}
          position={{
            lat: parseFloat(selectedPark.latitud),
            lng: parseFloat(selectedPark.longitud)
          }}
        >
          <div>
            <h2>{selectedPark.nombre}</h2>
            <p>{selectedPark.direccion}</p>
            <p><a class="buttonMicroClip" href={"https://maps.google.com/?q="+selectedPark.latitud+","+selectedPark.longitud}>Como llegar</a></p>
          </div>
        </InfoWindow>
      )}
    </GoogleMap>
  );
}

const MapWrapped = withScriptjs(withGoogleMap(Map));

export default function MapaPuntoCarga() {
  return (
    <div style={{ width: "99vw", height: "48vh" }}>
      <MapWrapped
        googleMapURL={`https://maps.googleapis.com/maps/api/js?v=3.exp&libraries=geometry,drawing,places&key=${
          "AIzaSyBauEMXNpAYf2wrK_QcSN2MZca80lWR-vI"
        }`}
        loadingElement={<div style={{ height: `100%` }} />}
        containerElement={<div style={{ height: `100%` }} />}
        mapElement={<div style={{ height: `100%` }} />}
      />
    </div>
  );
}
